import type { JSX } from 'react'

export const AccountSettingsIcon = (): JSX.Element => (
  <use href='#accountSettings' height='100%' width='100%' />
)
